import { render, staticRenderFns } from "./LmDownloads.vue?vue&type=template&id=18e563e8"
import script from "./LmDownloads.vue?vue&type=script&lang=ts"
export * from "./LmDownloads.vue?vue&type=script&lang=ts"
import style0 from "./LmDownloads.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModuleHeader: require('/app/components/base/ModuleHeader/ModuleHeader.vue').default,Download: require('/app/components/base/Download/Download.vue').default})
